var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('nav',{staticClass:"navbar navbar-light"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"back",on:{"click":function($event){return _vm.$router.go(-1)}}},[_c('i',{staticClass:"iconfont"},[_vm._v("")])])])])}
var staticRenderFns = []

export { render, staticRenderFns }